import React, { Component } from 'react';
import axios from 'axios';
import { observer } from 'mobx-react';
import { Button, Col, Label, Progress, Row, UncontrolledAlert } from 'reactstrap';
import Icon from '@availity/icon';

import { FaFilePdf, FaFileWord, FaFileExcel, FaFile, FaFileImage } from 'react-icons/fa';


import PropTypes from 'prop-types';
import { Field, FormGroup } from '@availity/form';
import ReimbursementStore from '@/WA_TAP/stores';


@observer
class AddFile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showErrorMessage: false,
            disableAddBtn: false
        };

        this.supportedExt = [".jpg", ".jpeg", ".tiff", ".pdf", ".xls", ".xlsx"]
    }

    componentDidMount() {
        const { index, fileObj, propsData } = this.props;
        const documentName = propsData.documentName;
        fileObj.documentName = documentName;
        ReimbursementStore.setSingleDocumentUploadDetails(index, fileObj);
    }

    onFileUpload = (e) => {
        // this.setState({percentageCompleted: undefined})
        const { index, fileObj, propsData } = this.props;
        const { files } = e.target;
        if (files && files.length > 0) {
            const file = files[0]
            const ext = file.name.slice(file.name.lastIndexOf("."))
            fileObj.fileName = file.name;
            // validate file Size
            const maxSize = 10 * 1024 * 1024;

            if (!this.supportedExt.includes(ext)) {
                fileObj.percetComp = -1;
                fileObj.fileError = "File extension ".concat(ext).concat(" not supported");
                this.setState({ showErrorMessage: true });
            }
            else if (file.size > maxSize) {
                fileObj.percetComp = -1;
                fileObj.fileError = "Upload unsuccessful due to file size exceeding 10MB. Please try again with a smaller file size.";
                this.setState({ showErrorMessage: true });
            }
            else {

                fileObj.fileError = "";
                let docName = "";
                docName = this.getDocName(propsData.documentName);
                const updatedFileName = "TAP ETP "
                    .concat(docName)
                    .concat(" - ")
                    .concat(ReimbursementStore.getProvAgencyAbbr(ReimbursementStore.providerInfo))
                    .concat(" - ")
                    .concat(ReimbursementStore.enrolleeInfo.providerOneId)
                    .concat("_")
                    .concat(new Date().toLocaleString("en-US", {timeZone: "America/Los_Angeles"}).replace(/\//g, "_").replace(/:/g, '_').replace(", ", '_')).replace(" ", "_").replace(/(\d{2})(\s[AP]M)/, '$1_$2')
                    .replace(" ", "")
                    .concat("_PST")
                    .concat(ext);

                    // Assign the updatedFileName to fileObj
                    fileObj.updatedFileName = updatedFileName;
                    ReimbursementStore.setSingleDocumentUploadDetails(index, fileObj);
                    const formData = new FormData();
                    const metaData = { fileName: updatedFileName, folderCheckByApp: 'TAP', bucket: 'assessment', documentName: this.state.documentName };
                    formData.append('metadata', JSON.stringify(metaData));
                    formData.append('file', file);
                    axios.post('/tapreimbursementrequestform/wa/upload/provconn/v1/attachments/file/assessment', formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                'meta-transid': crypto.randomUUID()
                            },
                            onUploadProgress: this.uploadProgress
                        }).then(res => {
                            fileObj.percetComp = 100;
                            fileObj.fileError = "";
                            ReimbursementStore.setSingleDocumentUploadDetails(index, fileObj);
                            this.setState({ showErrorMessage: true });
                        }).catch(error => {
                            fileObj.percetComp = -1;
                            fileObj.fileError = "File upload failed. Please try again.";
                            ReimbursementStore.setSingleDocumentUploadDetails(index, fileObj);
                            this.setState({ showErrorMessage: true });
                        });

            }
            ReimbursementStore.setSingleDocumentUploadDetails(index, fileObj);

        }


    }



    uploadProgress = (progressEvent) => {

        const { lengthComputable, loaded, total } = progressEvent;

        const { index, fileObj } = this.props;

        if (lengthComputable) {
            let percentage = Math.round((loaded * 100) / total);
            percentage = percentage && percentage === 100 ? 90 : percentage;
            if (percentage) {
                fileObj.percetComp = percentage;
                ReimbursementStore.setSingleDocumentUploadDetails(index, fileObj);
            }
        }
    }

   
  getFileIcon = (fileName) => {
        if (!fileName) {
            return <FaFile />; // Return a default icon if fileName is null or undefined
        }
        const extension = fileName.split('.').pop().toLowerCase();
        switch (extension) {
            case 'pdf':
                return <FaFilePdf />;
            case 'doc':
            case 'docx':
                return <FaFileWord />;
            case 'xls':
            case 'xlsx':
                return <FaFileExcel />;
            case 'jpg':
            case 'jpeg':
            case 'tiff':
                return <FaFileImage/>; 
            default:
                return <FaFile />;
        }
    };

    removeFile = (index) => {
        ReimbursementStore.setSingleDocumentUploadDetails(index, {});
    }

    handleBtnClick = (fileId) => {
        document.getElementById(fileId).click();
    }


    getDocName = (value) => {
        return value.replace(/ /g, '').replace("/", '');
    }

    render() {
        const { index, fileObj, fieldId } = this.props;
        const { percetComp, documentName, fileName, fileError } = fileObj;

        const fileIcon = this.getFileIcon(fileName);

        const { showErrorMessage, disableAddBtn } = this.state;

        return (
            <div className="add-file1">
                <Row>
                    <Col sm="12">
                        <Label>
                            <b>
                                Important:
                            </b> Individual file size cannot exceed <span className='text-danger'>10MB</span>. Supported file types include <span className='text-danger'>.Excel, .PDF, .jpg, .jpeg, .tiff</span>.
                        </Label>
                    </Col>
                </Row>
                <div className="mt-3" />
                {(percetComp === undefined || percetComp === -1) &&
                    <Row>

                        <Col sm="12" className='uploadFileDocument'>
                            <FormGroup className='label-font'>
                                <div>
                                    <Button className='btn btn-link btn-file upload-button' color='primary' outline onClick={() => this.handleBtnClick(fieldId)}>
                                        <i className="icon icon-plus-circle" />
                                        <span className="add-file">Add file</span>
                                    </Button>
                                    <Field
                                        type='file'
                                        id={fieldId}
                                        name={fieldId}
                                        onChange={this.onFileUpload}
                                        style={{ display: 'none' }}
                                        accept={this.state.supportedExt}
                                        aria-label="upload files"
                                        value={null}
                                    />
                                    <Field
                                        type='text'
                                        name={fieldId + "_value"}
                                        style={{ display: 'none' }}
                                    />
                                </div>
                            </FormGroup>
                        </Col>
                    </Row>
                }
                {percetComp !== undefined &&
                    <>
                        <Row className="pl-32 mt-3 align-items-center">
                            <Col sm="5">
                                <label>
                                    {fileIcon} <span className='file-color'>{fileName}</span>
                                </label>
                            </Col>

                            {
                                fileError !== null && fileError !== undefined && fileError !== '' ?
                                    <>
                                        <Col sm="6">
                                            <label className='text-danger'>{fileError}</label>
                                        </Col>
                                        <Col sm="1">
                                            <Button color="link" className="text-danger px-0" onClick={(event) => this.removeFile(index)}>
                                                <i className="icon icon-trash-empty" />
                                            </Button>
                                        </Col>
                                    </>
                                    :
                                    <>
                                        <Col sm="6">
                                            <Progress value={(() => { if (percetComp < 0) return 100; return percetComp; })()} color={(() => { if (percetComp === 100) return 'success'; if (percetComp === -1) return 'danger'; return 'primary' })()} />
                                        </Col>
                                        <Col sm="1">
                                            <Button color="link" className="text-danger px-0" onClick={(event) => this.removeFile(index)}>
                                                <i className="icon icon-trash-empty" />
                                            </Button>
                                        </Col>
                                    </>
                            }
                        </Row>
                        {(showErrorMessage && (percetComp === 100 || percetComp === -1)) &&
                            <Row className="pl-32 mt-3">
                                <Col>
                                    <UncontrolledAlert color={percetComp === 100 ? 'success' : 'danger'} fade>
                                        <strong>
                                            {percetComp === 100 ? 'Upload successfull..!' : 'Upload unsuccessfull..!'}
                                        </strong>
                                    </UncontrolledAlert>
                                </Col>
                            </Row>
                        }
                    </>
                }
                {
                    disableAddBtn ?
                        <Row className="pl-32 mt-3">
                            <Col>
                                <UncontrolledAlert color='danger' fade>
                                    <strong>
                                        Please enter filename first..!!!
                                    </strong>
                                </UncontrolledAlert>
                            </Col>
                        </Row> :
                        ""
                }

            </div >
        );

    }
}

export default AddFile;

AddFile.propTypes = {
    propsData: PropTypes.object,
    index: PropTypes.number,
    fileObj: PropTypes.shape({
        fileName: PropTypes.string,
        percetComp: PropTypes.number,
        fileError: PropTypes.string,
        documentName: PropTypes.string,
        updatedFileName: PropTypes.string
    }),
    fieldId: PropTypes.string
};
